import { useQuery } from "@tanstack/react-query";
import { baseUrl } from "./Requests";

export const AUTH_ME_QUERY_KEY = ["auth", "me"];

const AUTH_ME_STALE_TIME = 1000 * 60 * 5;
const AUTH_ME_GC_TIME = 1000 * 60 * 30;

export function resolveAuthProfileName(payload) {
  if (!payload || typeof payload !== "object") return "";

  const sources = [payload, payload.user, payload.data].filter(Boolean);
  for (const source of sources) {
    const value = source.display_name || source.displayName || "";
    if (value) return value;
  }

  return "";
}

export async function fetchAuthSession() {
  try {
    const response = await fetch(`${baseUrl}/me`, {
      credentials: "include",
    });

    if (!response.ok) {
      return {
        authenticated: false,
        profileName: "",
        payload: null,
      };
    }

    const payload = await response.json();
    if (payload?.authenticated === false) {
      return {
        authenticated: false,
        profileName: "",
        payload,
      };
    }

    return {
      authenticated: true,
      profileName: resolveAuthProfileName(payload),
      payload,
    };
  } catch (error) {
    return {
      authenticated: false,
      profileName: "",
      payload: null,
    };
  }
}

export function getAuthSessionQueryOptions(overrides = {}) {
  return {
    queryKey: AUTH_ME_QUERY_KEY,
    queryFn: fetchAuthSession,
    staleTime: AUTH_ME_STALE_TIME,
    gcTime: AUTH_ME_GC_TIME,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    ...overrides,
  };
}

export function useAuthSession(options = {}) {
  return useQuery(getAuthSessionQueryOptions(options));
}

export async function refreshAuthSession(queryClient) {
  return queryClient.fetchQuery(
    getAuthSessionQueryOptions({
      staleTime: 0,
    })
  );
}

export function setLoggedOutAuthSession(queryClient) {
  queryClient.setQueryData(AUTH_ME_QUERY_KEY, {
    authenticated: false,
    profileName: "",
    payload: null,
  });
}
